/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API47265Item {
  
  /** 发布时间 */
  publishTime?: string;
  
  /** 发布日各业务域的更新日志 ,DomainUpdateLogDTO */
  domainUpdateLogs?: API47265Item[];
  
};
    
  



export interface API47265Req {
  
  /** 发布起始时间 */
  publishStartTime?: string;
    
  /** 发布截至时间 */
  publishEndTime?: string;
    
  /** 当前页 */
  pageIndex?: string;
    
  /** 每页显示大小 */
  pageSize?: string;
    
};



export interface API47265Res {
  /** T  */
  list?: API47265Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 47265 按照日期展示各业务域更新内容

export interface IUseGetAPI47265Return {
  /** 按照日期展示各业务域更新内容: 接口请求状态 */
  isAPI47265Loading: boolean;
  /** 按照日期展示各业务域更新内容: 接口请求返回数据 */
  dataAPI47265: API47265Res;
  /**  按照日期展示各业务域更新内容: 接口数据请求方法 */
  fetchAPI47265Data:  (inputs: API47265Req, config?: YWRequestConfig) => Promise<API47265Res>;
  /** 按照日期展示各业务域更新内容: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47265 = ():IUseGetAPI47265Return => {
  let isMount = true;
  const [isAPI47265Loading, setIsAPI47265Loading] = useState(false);
  const [dataAPI47265, setDataAPI47265] = useState<API47265Res>({} as API47265Res);
  const requestUrl = `${basePath}/ywwl-admin/biz/domain/update/content/list`;

  const fetchAPI47265Data = async (inputs: API47265Req, config?: YWRequestConfig): Promise<API47265Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47265Req>) || {}) as API47265Req;
    
  
    if ( isMount ) {
      setIsAPI47265Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47265Res>(`${basePath}/ywwl-admin/biz/domain/update/content/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47265(res || {} as API47265Res);
        setIsAPI47265Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47265Loading(false);
      }
      return false as unknown as API47265Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47265Loading,
    dataAPI47265,
    fetchAPI47265Data,
    requestUrl,
  }
}

